import React, { useState } from 'react'
import ClickAwayListener from '@mui/material/ClickAwayListener'

import FavoriteTutorsPopup from './FavoriteTutorsPopup'
import ToolBarLink from '../ToolBarLink'
import FavoriteTutorsContent from './FavoriteTutorsContent'

import heartIcon from '../../../../assets/icon/heart-icon.svg'

const FavoriteTutors = () => {
  const [isTutorsPopupOpen, setIsTutorsPopupOpen] = useState(false)

  const handleTutorsPopupToggle = () => {
    setIsTutorsPopupOpen((prevState) => !prevState)
  }

  const handleTutorsPopupClose = () => {
    setIsTutorsPopupOpen(false)
  }

  return (
    <ClickAwayListener onClickAway={handleTutorsPopupClose}>
      <div>
        <FavoriteTutorsPopup
          title={<FavoriteTutorsContent />}
          open={isTutorsPopupOpen}
          onClose={handleTutorsPopupClose}
        >
          <div>
            <ToolBarLink
              as="button"
              icon={heartIcon}
              onClick={handleTutorsPopupToggle}
              label="Favorite Tutors"
            />
          </div>
        </FavoriteTutorsPopup>
      </div>
    </ClickAwayListener>
  )
}

export default FavoriteTutors
